/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
export const comboBoxReducer = (state, action) => {
    var _a, _b, _c, _d, _e;
    switch (action.type) {
        case 'open': {
            return { ...state, isOpen: true };
        }
        case 'close': {
            return { ...state, isOpen: false };
        }
        case 'select': {
            if (Array.isArray(state.selected)) {
                return { ...state };
            }
            return {
                ...state,
                selected: (_a = action.value) !== null && _a !== void 0 ? _a : state.selected,
                focusedIndex: (_b = action.value) !== null && _b !== void 0 ? _b : state.focusedIndex,
            };
        }
        case 'multiselect': {
            if (!Array.isArray(state.selected)) {
                return { ...state };
            }
            return { ...state, selected: action.value };
        }
        case 'focus': {
            if (Array.isArray(state.selected)) {
                return {
                    ...state,
                    focusedIndex: (_c = action.value) !== null && _c !== void 0 ? _c : -1,
                };
            }
            return {
                ...state,
                focusedIndex: (_e = (_d = action.value) !== null && _d !== void 0 ? _d : state.selected) !== null && _e !== void 0 ? _e : -1,
            };
        }
        default: {
            return state;
        }
    }
};
export const ComboBoxRefsContext = React.createContext(undefined);
ComboBoxRefsContext.displayName = 'ComboBoxRefsContext';
export const ComboBoxStateContext = React.createContext(undefined);
ComboBoxStateContext.displayName = 'ComboBoxStateContext';
export const ComboBoxActionContext = React.createContext(undefined);
ComboBoxActionContext.displayName = 'ComboBoxActionContext';
